import Vue from "vue";

import { URL_API } from "../../settings/apiConnect";

export default {
  actions: {
    async getLocationsData(context) {
      const response = await Vue.axios.get(`${URL_API}locationtype`);
      let data = response["data"];
      context.commit("updateLocationsData", data);
    },
    async createLocationData(context, name) {
      const config = {};
      const body = {
        name: name
      };
      await Vue.axios.post(`${URL_API}locationtype/store`, body, config);
      context.dispatch("getLocationsData");
    },
    async pushLocationData(context, { id, name }) {
      const config = {};
      const body = {
        id: id,
        name: name
      };
      await Vue.axios.post(`${URL_API}locationtype/update`, body, config);
      context.dispatch("getLocationsData");
    },
    async destroyLocationData(context, id) {
      const config = {};
      const body = {
        id: id
      };
      await Vue.axios.post(`${URL_API}locationtype/destroy`, body, config);
      context.dispatch("getLocationsData");
    }
  },
  mutations: {
    updateLocationsData(state, locationsData) {
      state.locationsData = locationsData;
    }
  },
  state: {
    locationsData: []
  },
  getters: {
    allLocationsData(state) {
      return state.locationsData;
    }
  }
};